'use client';

import { ActionIcon, Menu, Text } from '@mantine/core';
import { modals } from '@mantine/modals';
import { IconDots, IconEdit, IconTrash } from '@tabler/icons-react';
import { useRouter } from 'next/navigation';

interface Props {
  post: Post;
  setEdit: any;
}

export default function PostMenu({ post, setEdit }: Props) {
  const router = useRouter();

  async function handleDelete() {
    await fetch(`/api/posts/${post._id}`, {
      method: 'DELETE',
    });
    router.refresh();
  }

  const openDeleteModal = () =>
    modals.openConfirmModal({
      title: 'Delete Post',
      centered: true,
      children: (
        <Text size='sm'>
          Are you sure you want to delete your post? This action cannot be
          undone.
        </Text>
      ),
      labels: { confirm: 'Delete', cancel: 'Cancel' },
      confirmProps: { color: 'red' },
      onConfirm: () => handleDelete(),
    });

  return (
    <Menu withinPortal position='bottom-end' shadow='sm'>
      <Menu.Target>
        <ActionIcon size='lg'>
          <IconDots size={16} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          onClick={() => setEdit(true)}
          leftSection={<IconEdit size={16} />}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          onClick={openDeleteModal}
          leftSection={<IconTrash size={16} />}
          color='red'
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
